export const mapContextDeviceToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    categoryName: item.category.name,
  }));

  return result;
};

export const contextDeviceColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "categoryName", label: "Category", align: "center" },
];
